import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../contexts/AuthContext";
import { apiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { GoogleAuthButton } from "../components/GoogleAuthButton";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.display_name}`);
      if (u.is_admin) nav("/admin");
      else nav(u.role === "author" ? "/author" : "/reader");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-0 py-16">
      <div className="paper-card p-8">
        <div className="overline mb-2">Welcome back</div>
        <h1 className="rainbow-text text-3xl mb-6">Sign in to Faraway Sister Haven</h1>

        <GoogleAuthButton testId="login-google-btn" />
        <div className="flex items-center gap-3 my-5">
          <div className="flex-1 h-px" style={{ background: "var(--border-soft)" }} />
          <span className="text-xs" style={{ color: "var(--ink-muted)" }}>or with email</span>
          <div className="flex-1 h-px" style={{ background: "var(--border-soft)" }} />
        </div>

        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" />
          </div>
          <Button type="submit" disabled={loading} className="w-full btn-press btn-rainbow" data-testid="login-submit-btn">
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </form>
        <p className="text-sm text-slate-600 mt-6 text-center">
          New here?{" "}
          <Link to="/register" className="text-indigo-800 underline underline-offset-2" data-testid="login-goto-register">
            Create an account
          </Link>
        </p>
      </div>
    </div>
  );
}
